import React from 'react';

// Hook to manage sort state
export function useSort(defaultKey, defaultDir = 'asc') {
  const [sortKey, setSortKey] = React.useState(defaultKey);
  const [sortDir, setSortDir] = React.useState(defaultDir);

  function handleSort(key) {
    if (sortKey === key) {
      if (sortDir === 'asc') setSortDir('desc');
      else if (sortDir === 'desc') { setSortKey(defaultKey); setSortDir(defaultDir); }
      else setSortDir('asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  }

  function sortData(data, accessors = {}) {
    if (!sortKey) return data;
    return [...data].sort((a, b) => {
      const getVal = (obj) => {
        const accessor = accessors[sortKey];
        const val = accessor ? accessor(obj) : obj[sortKey];
        return val ?? '';
      };
      const av = getVal(a);
      const bv = getVal(b);
      let cmp = 0;
      if (typeof av === 'number' && typeof bv === 'number') cmp = av - bv;
      else cmp = String(av).toLowerCase().localeCompare(String(bv).toLowerCase());
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }

  return { sortKey, sortDir, handleSort, sortData };
}

// Sortable TH component
export default function SortTh({ label, sortKey, currentKey, currentDir, onSort, style = {}, align = 'left' }) {
  const isActive = currentKey === sortKey;
  const arrow = isActive ? (currentDir === 'asc' ? ' ↑' : ' ↓') : ' ↕';
  return (
    <th onClick={() => onSort(sortKey)} style={{
      cursor: 'pointer', userSelect: 'none', textAlign: align,
      color: isActive ? 'var(--navy)' : undefined,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {label}
      <span style={{
        fontSize: '0.85em', marginLeft: 3,
        color: isActive ? 'var(--navy)' : 'var(--text-muted)',
        opacity: isActive ? 1 : 0.5,
      }}>{arrow}</span>
    </th>
  );
}
